<div
  class="bg-input-background box-border flex w-full text-base"
  [ngClass]="{
    'cursor-not-allowed opacity-60': ngControl.control!.disabled,
  }">
  @let hasError = ngControl.errors && ngControl.touched;
  <div class="relative w-full bg-inherit">
    <input
      [attr.data-bwignore]="ignoreBitwardenAutofill ? 'true' : null"
      [attr.data-testid]="id() | appendTestId: 'input'"
      [formControl]="ngControl.control! | toFormControl"
      [step]="step"
      [id]="id()"
      [placeholder]="label() ?? ''"
      type="number"
      class="border-input rounded-input peer p-input focus:border-input-focus text-standard-text w-full bg-transparent pr-20! placeholder-transparent focus:ring-0"
      [ngClass]="{
        'border-input-error': hasError,
        'border-input-ring': !hasError,
        'pointer-events-none': ngControl.disabled,
      }" />
    <label
      [attr.data-testid]="id() | appendTestId: 'label'"
      class="peer-placeholder-shown:text-input-text peer-focus:text-input-focus pointer-events-none absolute -top-2 right-4 left-4 mx-1 w-fit max-w-[calc(100%-2rem)] cursor-text overflow-hidden bg-inherit px-1 text-sm overflow-ellipsis whitespace-nowrap transition-all peer-placeholder-shown:top-3.5 peer-placeholder-shown:max-h-6 peer-placeholder-shown:text-base peer-focus:-top-2 peer-focus:text-sm"
      [for]="id()"
      [ngClass]="{
        'text-input-error': hasError,
        'text-standard-text': !hasError,
      }">
      {{ formattedLabel() }}
    </label>
    @if (!ngControl.control!.disabled) {
      <div
        class="text-input-label absolute top-3 right-4 flex items-center gap-3 text-lg">
        <button
          type="button"
          aria-label="Wert erhöhen"
          [attr.data-testid]="id() | appendTestId: 'increase'"
          class="hover:bg-standard-hover-main/30 hover:border-standard-text-secondary focus:bg-standard-hover-main/30 focus:border-standard-text-secondary flex h-7 w-7 cursor-pointer items-center justify-center rounded-sm border-1 border-transparent focus:outline-none"
          (click)="increaseValue()">
          <span class="material-symbols-rounded">add</span>
        </button>
        <button
          type="button"
          aria-label="Wert verringern"
          [attr.data-testid]="id() | appendTestId: 'decrease'"
          class="hover:bg-standard-hover-main/30 hover:border-standard-text-secondary focus:bg-standard-hover-main/30 focus:border-standard-text-secondary flex h-7 w-7 cursor-pointer items-center justify-center rounded-sm border-1 border-transparent focus:outline-none"
          (click)="decreaseValue()">
          <span class="material-symbols-rounded">remove</span>
        </button>
      </div>
    }
    @if (hasError && !errorTemplate()) {
      <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
        <ng-content></ng-content>
      </aw-error-message>
    }
    @if (hasError && errorTemplate()) {
      <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
        <ng-container *ngTemplateOutlet="errorTemplate()!"></ng-container>
      </aw-error-message>
    }
  </div>
</div>
